<div class="core-edit-max-width" *ngIf="!loading">
  <div class="flex-row-space-between">
    <h1>Firmware bearbeiten</h1>
    <core-button-slight
      *ngIf="userCanEdit"
      (click)="onDelete()"
      [type]="InputButtonIconType.DELETE">
    </core-button-slight>
  </div>

  <form *ngIf="form" [formGroup]="form">

    <core-input-dropdown
      id="softwareType"
      label="Software Type"
      [options]="softwareTypeOptions"
      formControlName="softwareType"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="moduleType"
      label="Module Type"
      [options]="moduleTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="moduleTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="chipType"
      label="Chip Type"
      [options]="chipTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="chipTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="displayType"
      label="Display Type"
      [options]="displayTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="displayTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-number
      formControlName="version"
      id="version"
      label="Version"
      [disabled]="true"
      [min]="0">
    </core-input-number>

    <div class="col-12 mb-3">
      <div class="field-checkbox">
        <p-checkbox
          formControlName="isInitializer"
          [binary]="true"
          inputId="isInitializer"
          [disabled]="!userCanEdit">
        </p-checkbox>
        <label for="isInitializer" class="ml-2">Ist Initializer Software?</label>
      </div>
    </div>

    <!-- show current file download link similar to viewer section -->
    <div class="col-12" style="margin-bottom: 1rem" *ngIf="downloadUrl">
      <a [href]="downloadUrl" target="_blank" rel="noopener">Firmware Datei herunterladen</a>
    </div>

    <div class="col-12">
      <label for="firmwareFile">Firmware-Datei (.bin)</label>
      <input type="file" id="firmwareFile" accept=".bin" (change)="onFileSelected($event)" [disabled]="!userCanEdit" />
    </div>

    <core-button-submit
      (click)="save()"
      [disabled]="form.invalid || form.disabled"
      id="button_submit">
    </core-button-submit>

    <div *ngIf="error" class="mt-2 alert alert-danger">{{ error }}</div>
  </form>
</div>
<div class="container" *ngIf="loading">
  <p-skeleton height="2rem"></p-skeleton>
  <p-skeleton height="2rem"></p-skeleton>
  <p-skeleton height="2rem"></p-skeleton>
</div>
